// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__M2dKt","tagline":"Intro_tagline__q5ftA","subtagline":"Intro_subtagline__-jQTb"};